import { render, staticRenderFns } from "./dashboardfault0308.vue?vue&type=template&id=ef68a11e&scoped=true&"
import script from "./dashboardfault0308.vue?vue&type=script&lang=js&"
export * from "./dashboardfault0308.vue?vue&type=script&lang=js&"
import style0 from "./dashboardfault0308.vue?vue&type=style&index=0&id=ef68a11e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef68a11e",
  null
  
)

export default component.exports